export const routers = {
  home: '/',
  post_detail: postId => `/tin/${postId}`,
  article: '/tin/tin-tuc',
  video: '/videos',
  short_videos: '/video-ngan',
  short_video_detail: (short_video_id) =>  `/video-ngan/${short_video_id}`,
  products: '/cho-2nong',
  modules: {
    weather: '/chuyen-muc/thoi-tiet',
    npk: '/chuyen-muc/npk',
    market_price: '/chuyen-muc/gia-ca-thi-truong',
  },
  shop: shop_id => `/thanh-vien/${shop_id}`,
  manager: {
    comment: '/thanh-vien/quan-ly-binh-luan',
  },
  notice_schedule: (schedule_id) =>  `/thanh-vien/thiet-lap-thong-bao/chinh-sua/${schedule_id}`,
  comment: {
    post: (post_id) => `/tin/${post_id}`,
    video: (video_id) => `/videos/${video_id}`,
    article: (article_id) => `/tin-tuc/${article_id}`,
    product: (product_id) => `/san-pham/${product_id}`,
    technical_process: (technical_process_id) => `/quy-trinh-ky-thuat/danh-muc/${technical_process_id}`,
    image: (post_id, image_id) => `/tin/${post_id}/i/${image_id}`,
  },
  subComment: {
    post: (post_id) => `/tin/${post_id}`,
    video: (video_id) => `/videos/${video_id}`,
    article: (article_id) => `/tin-tuc/${article_id}`,
    product: (product_id) => `/san-pham/${product_id}`,
    technical_process: (technical_process_id) => `/quy-trinh-ky-thuat/danh-muc/${technical_process_id}`,
    image: (post_id, image_id) => `/tin/${post_id}/i/${image_id}`,
  },
  invoice: {
    sales_order: (invoice_id) => `/thanh-vien/thong-tin-don-hang-ban/${invoice_id}`,
    purchase_order: (invoice_id) => `/thanh-vien/thong-tin-don-hang-mua/${invoice_id}`,
    business_order: (invoice_id, business_id) => `/lien-ket-danh-nghiep/thong-tin-don-hang/${invoice_id}/business/${business_id}`,
  },
  refund_invoice: {
    sales_refund_order: (refund_invoice_id) => `/thanh-vien/thong-tin-don-ban-hoan-tra/${refund_invoice_id}`,
    purchase_refund_order: (refund_invoice_id) => `/thanh-vien/thong-tin-don-mua-hoan-tra/${refund_invoice_id}`,
    business_refund_order: (refund_invoice_id, business_id) => `/lien-ket-danh-nghiep/thong-tin-don-hang-hoan-tra/${refund_invoice_id}/business/${business_id}`,
  },
  business_association: (invoice_id, business_id) => `/lien-ket-danh-nghiep/thong-tin-don-hang/${invoice_id}/business/${business_id}`,
  market_place: (market_price_id) => `/chuyen-muc/thong-tin-gia-ca-thi-truong/${market_price_id}`,
  system: {
    article: '/tin/tin-tuc',
    post: '/',
    weather: '/chuyen-muc/thoi-tiet',
    npk: '/chuyen-muc/npk',
    market_price: '/chuyen-muc/gia-ca-thi-truong',
    technical_process: '/quy-trinh-ky-thuat',
    video: '/videos',
    traceability: '/chuyen-muc/truy-xuat-nguon-goc',
    business_association: '',
    handbook_of_pest: '/diagnostics',
    shop_gitf: '/shop-qua-tang',
    short_video: '/videos',
  },
  default: '',
};
